import Table from 'react-bootstrap/Table';
import {useParams, useLocation} from 'react-router-dom';
import {useEffect, useState} from "react";
import {WashnetBackend} from "../services/WashnetBackend";
import {ReportHeader} from '../components/ReportHeader';
import {ItemDetailRequest, ItemDetailResponse, ItemDetailTotals} from "../models/reports"
import {secToHMS, unixTimeToTimeString, unixTimeToDateString} from "../util";
import {ModalShowMessage} from "../admin/ModalShowMessage"
import {ReportParams} from "../models/reports";
import {Data} from "../components/Data"

export interface ItemDetailProps {
    backend: WashnetBackend
}

export const ReportItemDetail: React.FC<ItemDetailProps> = (props: ItemDetailProps) => {

    const {customerId, siteId, systemId, machineId} = useParams();
    const [itemDetail, setItemDetail] = useState<ItemDetailResponse>();
    const [totals, setTotals] = useState<ItemDetailTotals>();

    const state:ReportParams = useLocation().state;

    useEffect(() => {
        // Make sure we have these IDs.
        if (customerId === undefined || siteId === undefined || systemId === undefined || machineId === undefined) {
            console.log("customerId, siteId, systemId or machineId is undefined");
            return;
        }

        // Outgoing to backend.
        let params: ItemDetailRequest = {
            customerId: customerId,
            siteId: siteId,
            systemId: systemId,
            machineId: machineId,
            startDate: state.startDate,
            endDate: state.endDate
        }

        props.backend.getItemDetailReport(params)
        .then((response: ItemDetailResponse) => {
            setItemDetail(response)

            let t:ItemDetailTotals = {
                weight: 0,
                timeInMachine: 0,
                timeProcessing: 0,
                timeWaitingToUnload: 0,
                timeInAlarm: 0,
                timeInManual: 0,
                timeOffline: 0
            }
        
            // Sum each column in the rows of the response set.
            let r:ItemDetailResponse = response as ItemDetailResponse;
            r.response.forEach((element) => {
                t.weight += element.weight;
                t.timeInMachine += element.timeInMachine;
                t.timeProcessing += element.timeProcessing;
                t.timeWaitingToUnload += element.timeWaitingToUnload;
                t.timeInAlarm += element.timeInAlarm;
                t.timeInManual += element.timeInManual;
                t.timeOffline += element.timeOffline;
            })

            setTotals(t);
        })
        .catch((error) => {
            setAlertMessage(error.message);
            setShowAlert(true);
        })

    }, [customerId, siteId, systemId, machineId]);

    ///////////////////////////////////
    // For the alert message
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const handleCloseMessage = () => {
        setShowAlert(false);
    }

    return (
        <div>
            <ReportHeader title="Item Detail" machineName={state.machineName} startDate={state.startDate} endDate={state.endDate} timezone={state.timezone} />

            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                    <th>Item</th>
                    <th>Formula</th>
                    <th>Customer</th>
                    <th>Weight</th>
                    <th>Entry Time/Date</th>
                    <th>Exit Time/Date</th>
                    <th>Time In Machine</th>
                    <th>Time Processing</th>
                    <th>Time Wait To Unload</th>
                    <th>Time In Alarm</th>
                    <th>Time In Manual</th>
                    <th>Time Offline</th>
                    </tr>
                </thead>
                <tbody>
                    {
                    itemDetail !== undefined &&
                    <>
                        {
                        itemDetail.response.map((item, j) =>
                            <tr key={j.toString()}>
                            <td><Data value={item.item}/></td>
                            <td><Data value={item.formula}/></td>
                            <td><Data value={item.customer}/></td>
                            <td><Data value={item.weight}/></td>
                            <td>{unixTimeToTimeString(item.enterDateTime, true, state.timezone.toString())}<br/>{unixTimeToDateString(item.enterDateTime, false)}</td>
                            <td>{unixTimeToTimeString(item.exitDateTime, true, state.timezone.toString())}<br/>{unixTimeToDateString(item.exitDateTime, false)}</td>
                            <td>{secToHMS(item.timeInMachine)}</td>
                            <td>{secToHMS(item.timeProcessing)}</td>
                            <td>{secToHMS(item.timeWaitingToUnload)}</td>
                            <td>{secToHMS(item.timeInAlarm)}</td>
                            <td>{secToHMS(item.timeInManual)}</td>
                            <td>{secToHMS(item.timeOffline)}</td>
                            </tr>
                        )
                        }
                    </>
                    }
                    {
                    totals !== undefined &&
                    <>
                        <tr>
                        <td>Totals:</td>
                        <td></td>
                        <td></td>
                        <td>{totals.weight}</td>
                        <td></td>
                        <td></td>
                        <td>{secToHMS(totals.timeInMachine)}</td>
                        <td>{secToHMS(totals.timeProcessing)}</td>
                        <td>{secToHMS(totals.timeWaitingToUnload)}</td>
                        <td>{secToHMS(totals.timeInAlarm)}</td>
                        <td>{secToHMS(totals.timeInManual)}</td>
                        <td>{secToHMS(totals.timeOffline)}</td>
                        </tr>
                    </>
                    }
                </tbody>
            </Table>
            <hr/>

            {/* Modal to show message. */}
            <ModalShowMessage show={showAlert}
                message={alertMessage}
                variant="danger"
                handleClose={handleCloseMessage}
            />

        </div>
    );
}
